import React, { useState } from 'react';
interface SidebarSectionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}
export const SidebarSection = ({
  title,
  children,
  defaultOpen = false
}: SidebarSectionProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <details className="mb-4" open={isOpen} data-id="element-191">
      <summary className="text-xs font-semibold text-command-text-muted uppercase p-2 cursor-pointer list-none flex items-center gap-1 hover:text-white" onClick={e => {
      e.preventDefault();
      setIsOpen(!isOpen);
    }} data-id="element-192">
        <span className="inline-block text-[8px] mr-1 transition-transform duration-200" style={{
        transform: isOpen ? 'rotate(90deg)' : 'none'
      }} data-id="element-193">
          ►
        </span>
        {title}
      </summary>
      {children}
    </details>;
};